import React from 'react';
import classnames from 'classnames';

import { importStatic } from 'utils';

import classes from './index.module.css';

const ROUTES = {
  matches: '/matches/',
  home: '/',
};
const testId = 'logo';

const Logo = ({ userLoggedIn = false, noLinks = false, containerClassName = '' }) => {
  const goToMatches = () => {
    window.location.href = ROUTES.matches;
  };

  const goToHome = () => {
    window.location.href = ROUTES.home;
  };

  if (noLinks) {
    return (
      <span data-testid={testId} className={`navbar-brand mr-0 ${containerClassName}`}>
        <img
          className={classnames(classes.mobileLogo, 'd-lg-none', {
            'd-block': userLoggedIn,
            'd-none': !userLoggedIn,
          })}
          width="36"
          height="36"
          src={importStatic('/ui-router/logo/logo_mobile_white.png')}
          alt="Zippia Official Logo"
        />
        <img
          className={classnames(classes.desktopLogo, 'd-lg-block', {
            'd-none': userLoggedIn,
          })}
          width="160"
          height="36"
          src={importStatic('/ui-router/logo/full.png')}
          alt="Zippia Official Logo"
        />
      </span>
    );
  }

  return (
    <>
      <a
        data-testid={testId}
        className={`navbar-brand mr-0 ${containerClassName}`}
        href={userLoggedIn ? ROUTES.matches : ROUTES.home}
        onClick={userLoggedIn ? goToMatches : goToHome}
      >
        <img
          className={classnames(classes.mobileLogo, 'd-lg-none', {
            'd-block': userLoggedIn,
            'd-none': !userLoggedIn,
          })}
          width="36"
          height="36"
          src={importStatic('/ui-router/logo/logo_mobile_white.png')}
          alt="Zippia Official Logo"
        />
        <img
          className={classnames(classes.desktopLogo, 'd-lg-block', {
            'd-none': userLoggedIn,
          })}
          width="160"
          height="36"
          src={importStatic('/ui-router/logo/full.png')}
          alt="Zippia Official Logo"
        />
      </a>
    </>
  );
};

export default React.memo(Logo);
